import { get } from 'lodash';

const APP_PORT_LOCAL = {
  '3000': 'mod',
  '3001': 'pace',
};

export const DEFAULT_GRID_SIZE = 15;

export const reactApp = () => {
  const href = window.location.href;
  const params = {
    apiUrl: '',
    apiNetUrl: '',
    apiJavaUrl: '',
    clientId:
      href.includes('mod.myeyedr.com') || href.includes('pace.myeyedr.com')
        ? 'b785e81b-4788-48dc-881c-c5feda775be1'
        : '6c9fa750-e9c6-4311-9255-58b46446ff51',
    tenantId: 'e3ddc75a-a893-4372-a9ae-006db73001df',
    redirectUri: '',
    routerBasename: '',
  };

  if (href.includes('moddev.myeyedr.com')) {
    params.apiUrl = `https://apiorchestratordev.azure-api.net/mod/v1`;
    params.apiJavaUrl = `https://app-moddevapi.azurewebsites.net/api`;
    params.redirectUri = 'https://moddev.myeyedr.com';
    params.routerBasename = '';
    params.apiNetUrl = `https://apiorchestratordev.azure-api.net`;
  } else if (href.includes('modtest.myeyedr.com')) {
    params.apiUrl = `https://apiorchestratorqa.azure-api.net/mod/v1`;
    params.apiJavaUrl = `https://app-modtestapi.azurewebsites.net/api`;
    params.redirectUri = 'https://modtest.myeyedr.com';
    params.routerBasename = '';
    params.apiNetUrl = `https://apiorchestratorqa.azure-api.net`;
  } else if (href.includes('https://mango-forest-0d1f1260f.1.azurestaticapps.net')) {
    params.apiUrl = `https://app-moddevapi.azurewebsites.net/api`;
    params.apiJavaUrl = `https://app-moddevapi.azurewebsites.net/api`;
    params.redirectUri = 'https://mango-forest-0d1f1260f.1.azurestaticapps.net';
    params.routerBasename = '';
    params.apiNetUrl = `https://apiorchestratorqa.azure-api.net`;
  } else if (href.includes('modqa1.myeyedr.com')) {
    params.apiUrl = `https://app-modqa1api-adczgwcsatfsaucx.eastus2-01.azurewebsites.net/api`;
    params.apiJavaUrl = `https://app-modtestapi.azurewebsites.net/api`;
    params.redirectUri = 'https://modqa1.myeyedr.com';
    params.routerBasename = '';
    params.apiNetUrl = `https://apiorchestratorqa.azure-api.net`;
  } else if (href.includes('modtraining.myeyedr.com')) {
    params.apiUrl = `https://apiorchestratortraining.azure-api.net/mod/v1`;
    params.apiJavaUrl = `https://app-modtrainingapi.azurewebsites.net/api`;
    params.redirectUri = 'https://modtraining.myeyedr.com';
    params.routerBasename = '';
    params.apiNetUrl = `https://apiorchestratortraining.azure-api.net`;
  } else if (href.includes('mod.myeyedr.com')) {
    params.apiUrl = `https://med-api-orchestrator-prod.azure-api.net/mod/v1`;
    params.apiJavaUrl = `https://app-modprodapi.azurewebsites.net/api`;
    params.redirectUri = 'https://mod.myeyedr.com';
    params.routerBasename = '';
    params.apiNetUrl = `https://med-api-orchestrator-prod.azure-api.net`;
  } else if (href.includes('lemon-hill-0373ec00f') || href.includes('pacedev.myeyedr.com')) {
    params.apiUrl = `https://apiorchestratordev.azure-api.net/pace/v1`;
    params.redirectUri = 'https://pacedev.myeyedr.com';
    params.routerBasename = '';
    params.apiNetUrl = `https://apiorchestratordev.azure-api.net`;
  } else if (href.includes('blue-ground-04278810f') || href.includes('pacetest.myeyedr.com')) {
    params.apiUrl = `https://apiorchestratorqa.azure-api.net/pace/v1`;
    params.redirectUri = 'https://pacetest.myeyedr.com';
    params.routerBasename = '';
    params.apiNetUrl = `https://apiorchestratorqa.azure-api.net`;
  } else if (href.includes('paceqa1.myeyedr.com')) {
    params.apiUrl = `https://app-paceqa1api-c7gpczcffjbjgdc7.eastus2-01.azurewebsites.net`;
    params.redirectUri = 'https://paceqa1.myeyedr.com';
    params.routerBasename = '';
    params.apiNetUrl = `https://apiorchestratorqa.azure-api.net`;
  } else if (href.includes('pacetraining.myeyedr.com')) {
    params.apiUrl = `https://apiorchestratortraining.azure-api.net/pace/v1`;
    params.redirectUri = 'https://pacetraining.myeyedr.com';
    params.routerBasename = '';
    params.apiNetUrl = `https://apiorchestratortraining.azure-api.net`;
  } else if (href.includes('pace.myeyedr.com')) {
    params.apiUrl = `https://med-api-orchestrator-prod.azure-api.net/pace/v1`;
    params.redirectUri = 'https://pace.myeyedr.com';
    params.routerBasename = '';
    params.apiNetUrl = `https://med-api-orchestrator-prod.azure-api.net`;
  } else if (href.includes('localhost')) {
    const port = get(href.match(/:([0-9]+)\//), '[1]');
    params.apiJavaUrl = `https://app-moddevapi.azurewebsites.net/api`;
    params.apiUrl = 'https://apiorchestratordev.azure-api.net/mod/v1';
    params.apiNetUrl = `https://apiorchestratordev.azure-api.net`;
    params.redirectUri = `http://localhost:${port}`;
  }

  return params;
};

export const ZIP_VALIDATION_RULE = {
  pattern: /^\d{5}(\d{4})?$/,
  message: '5/9 digit zip code allowed',
};

export const STATE_VALIDATION_RULE = {
  pattern: /^[A-Z]{2}$/,
  message: 'Enter 2 letter state code',
};

export const PHONE_VALIDATION_RULE = {
  pattern: /^([0-9]{3})-([0-9]{3})-([0-9]{4})$/,
  message: "Write number in format: '111-111-1111",
};

export const EMAIL_VALIDATION_RULE = {
  pattern: /^[A-Za-z0-9._%+-]+@myeyedr\.com$/,
  message: 'Write email in format: xyz@myeyedr.com',
};

export const OFFICE_NUMBER_VALIDATION_RULE = {
  pattern: /^MED-\d{1,4}$/,
  message: 'Enter in the format MED-XXXX',
};

export const EMAIL_REQUIRED_RULE = {
  required: true,
  message: 'Please enter email id',
};

export const NPI_VALIDATION_RULE = {
  pattern: /^[0-9]{10}$/,
  message: 'NPI Number should be 10 digits only',
};

export const NAME_REQUIRED_RULE = {
  required: true,
  message: 'Please enter doctor name',
};

export const YEAR_VALIDATION_RULE = {
  pattern: /^[0-9]{4}$/,
  message: 'Year should be a 4-digit number only.',
};

export const AMOUNT_VALIDATION_RULE = {
  pattern: /^[1-9]\d*(\.\d+)?$/,
  message: 'Please enter a valid amount.',
};

export const INTEGER_VALIDATION_RULE = {
  pattern: /^[0-9]+$/,
  message: 'Please enter a valid integer.',
};
